<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="signup-page-contaier pt-md-4 py-2 px-md-5 px-3">
    <div class="row no-gutters">
      <div class="offset-xl-2 col-xl-8 offset-lg-1 col-lg-10 col-12">
        <div class="card border-0">
          <div class="signup-page-card d-flex flex-sm-row flex-column py-2 pb-md-4 card-body">
            <div class="signup-poster-section col-sm-6 col-12 oder-sm-0 order-1">
                <div class="d-flex justify-content-center align-items-center h-100">
                  <img src="assets/img/signup-blank.png" alt="signup" srcset="" class="img-fluid">
                </div> 
            </div>
            <div class="signup-form-section col-sm-6 col-12 order-sm-1 order-0">
              <div class="form-header">
                  <div class="company-logo pt-2 px-2">
                    <div class="d-flex flex-column align-items-center justify-content-center">
                      <img src="assets/img/logo-4.png" alt="logo" srcset="" class="img-fluid w-70px mx-1">
                      <h1 class="m-0 title">Smart<span class="dine">Dine</span></h1>
                    </div>
                    <div class="text-center pt-2">
                      <div class="form-title mb-2">Sign Up to your account</div>
                      <div class="form-subtitle pb-2 px-sm-2 px-4">Already have an account? Click to <a href="#" routerLink="/login" class="fw-bold text-decoration-none text-color-secondary">Sign In</a></div>
                    </div>
                  </div>
              </div>
              <form class="form" [formGroup]="signUpform" (ngSubmit)="onStep1FormSubmit()" *ngIf="stage === 1">
                <div class="ion-text-center form-subtitle py-2">Please provide below information.</div>
                <ion-list class="px-sm-4 px-2">
                  <ion-item lines="none" class="error" *ngIf="errorMessage">
                    <ion-label class="ion-text-center error-message bg-light" [innerText]="errorMessage"></ion-label>
                  </ion-item>
                  <ion-item lines="full" class="form-inputs mb-2">
                    <ion-icon class="me-1 form-input-icon mt-n-3px" slot="start" name="person-outline"></ion-icon>
                    <ion-input class="mt-n-12px mx-1" placeholder="Full Name" autocomplete="off" type="text" formControlName="name"></ion-input>
                  </ion-item>
                  <ion-item lines="full" class="form-inputs mb-2">
                    <ion-icon class="me-1 form-input-icon mt-n-3px" slot="start" name="phone-portrait-outline"></ion-icon>
                    <ion-select formControlName="countryCode" class="country-code-input mt-n-12px">
                      <ion-select-option value="+91">+91</ion-select-option>
                      <ion-select-option value="+1">+1</ion-select-option>
                    </ion-select>
                    <ion-input class="mt-n-12px mx-1" placeholder="Phone Number" autocomplete="off" type="text" formControlName="phoneNumber"></ion-input>
                  </ion-item>
                  <ion-item lines="full" class="form-inputs mb-2">
                    <ion-icon class="me-1 form-input-icon mt-n-3px" slot="start" name="mail-outline"></ion-icon>
                    <ion-input class="mt-n-12px mx-1" placeholder="Email" autocomplete="off" type="text" formControlName="email"></ion-input>
                  </ion-item>
                  <div class="d-flex flex-column mb-2">
                    <ion-item lines="full" class="form-inputs">
                      <ion-icon class="me-1 form-input-icon mt-n-3px" slot="start" [name]="hidePassword?'lock-closed-outline':'lock-open-outline'"></ion-icon>
                      <ion-input class="mt-n-12px mx-1" placeholder="Password" autocomplete="off" [type]="hidePassword?'password':'text'" formControlName="password" (ngModelChange)="onPasswordFieldFocus()"></ion-input>
                      <ion-button clear fill="clear" slot="end" class="pwd-visibility-button mt-n-12px" (click)="togglePasswordVisibility()" [title]="hidePassword?'Show':'Hide'">
                        <ion-icon class="form-input-icon" [name]="hidePassword?'eye-outline':'eye-off-outline'" [title]="hidePassword?'Show':'Hide'"></ion-icon>
                      </ion-button>
                    </ion-item>
                    <div class="px-sm-3 px-2">
                      <div *ngFor="let criterion of passwordCriteria">
                        <ion-label class="ion-text-start password-hint" [ngClass]="{'valid': validateCriterion(signUpform?.get('password').value, criterion.criterion) && isPasswordTouched, 'invalid': !validateCriterion(signUpform?.get('password').value, criterion.criterion) && isPasswordTouched, 'info': !isPasswordTouched }">
                          <ion-icon [name]="criterion.icon" [color]="criterion.color"></ion-icon>
                          {{ criterion.criterion }}
                        </ion-label>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center"> 
                    <div class="mx-1">
                      <ion-checkbox class="checkbox-input" mode="ios" formControlName="agreeToTC" (click)="agreeToTCAction()"></ion-checkbox>
                    </div>
                    <div class="mx-1 terms-conditions-link">
                      <a class="" (click)="showPrivacy()">
                        I agree to SmartdineNow Privacy Policy, Terms and Conditions
                      </a>
                    </div>
                </div>
                </ion-list>
                
                <div class="actions px-sm-4 px-3">
                  <ion-button class="mb-2 bg-color-1283f1 border-radius-20px" expand="block" share="round" type="submit" [disabled]="signUpButtonDisabled">
                    Create Account
                  </ion-button>
                </div>
              </form>
    
              <form class="form" [formGroup]="verficationform" (ngSubmit)="onStep2FormSubmit()" *ngIf="stage === 2">
                <div class="ion-text-center form-subtitle py-2">Please enter verification code.</div>
                <ion-list class="px-sm-4 px-2">
                  <ion-item lines="none" class="error" *ngIf="errorMessage">
                    <ion-label class="ion-text-center verification-message" [innerText]="errorMessage"></ion-label>
                  </ion-item>
                  <ion-item lines="full" class="form-inputs mb-2">
                    <ion-icon class="me-1 form-input-icon  mt-n-3px" slot="start" name="checkmark-done-outline"></ion-icon>
                    <ion-input class="mt-n-12px mx-1" placeholder="Verification Code" autocomplete="off" type="text" formControlName="verificationCode"></ion-input>
                    <ion-button class="mt-n-12px mx-1" (click)="resendCodeAction()" [disabled]="resendCodeDisabled">Resend Code</ion-button>
                  </ion-item>
                </ion-list>
                <div class="px-sm-4 px-2 actions">
                  <ion-button class="mb-2 bg-color-1283f1 border-radius-20px" expand="block" share="round" type="submit">
                    Verify
                  </ion-button>
                  <div class="mb-2 ion-text-center divider"><span class="py-2 px-3 text-white">OR</span></div>
                  <ion-button class="mb-2 border-radius-20px" expand="block" share="round" color="secondary" routerLink="/login" fill="outline">
                    Log in
                  </ion-button>
                </div>
              </form>
    
              <div class="form-success px-sm-4 px-2" *ngIf="stage === 3">
                <div class="ion-text-center form-success-logo">
                  <ion-icon color="success" class="py-2 success-verify-icon" name="checkmark-circle-outline"></ion-icon>
                </div>
                <div class="text-center text-light success-verify-message">Your account has been verifed successfully!<br>Please log in to continue.</div>
                <div class="px-sm-4 px-2">
                  <ion-button class="mb-2 border-radius-20px" expand="block" share="round" color="secondary" routerLink="/login">
                    Log in
                  </ion-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>
